import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {ResetPasswordService} from "./reset-password.service";
import {CommonsService} from "@core/service/commons.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.css']
})
export class ResetPasswordComponent implements OnInit {
  @ViewChild('resetPasswordForm') resetPasswordForm: NgForm;
  public resetPasswordObj:any = {};
  sendEmail(){
    for (let item in this.resetPasswordForm.controls) {
      this.resetPasswordForm.controls[item].markAsDirty();
      this.resetPasswordForm.controls[item].updateValueAndValidity();
    }
    if (!this.resetPasswordForm.valid) {
      return;
    }
    if(this.selectIndex == 1){
      let param = {
        login:this.resetPasswordObj.account,
        email:this.resetPasswordObj.email
      };
      this.resetPasswordService.sendEmail(param).subscribe((data)=>{
        this.commonsService.showSuccessMessage('passport.reset-password.emailSendSuccess');
        this.router.navigateByUrl('/passport/send-email-success');
      })
    }else if(this.selectIndex == 2){
      let param = {
        phone:this.resetPasswordObj.account,
        email:this.resetPasswordObj.email
      };
      this.resetPasswordService.sendEmailByPhone(param).subscribe((data)=>{
        this.commonsService.showSuccessMessage('passport.reset-password.emailSendSuccess');
        this.router.navigateByUrl('/passport/send-email-success');
      })
    }

  }
  constructor(private resetPasswordService:ResetPasswordService,private commonsService:CommonsService,private router:Router) { }

  //登录名或者手机号
  public selectIndex = 1;
  changeSelect(){
    this.resetPasswordForm.reset();
  }
  ngOnInit() {
  }

  backLoad(){
    this.router.navigateByUrl('/passport/login');
  }
}
